import { observer } from 'mobx-react';
import { Text, Inline, Badge } from 'braid-design-system';
import { FilterDrawer } from '../FilterSideBar/FilterDrawer';
import { FilterButton } from './FilterButton';
import { useStores } from 'src/utils/hooks/useStores';
import type { IJobApplicationStore } from 'src/stores/JobApplicationStore';
import { useState } from 'react';
import { useTranslations } from '@vocab/react';
import translations from './.vocab';

export const FilterActionButton: React.FC = observer(() => {
  const [showDrawer, setShowDrawer] = useState(false);
  const { jobApplicationStore } = useStores();
  const { filtersStore } = jobApplicationStore as IJobApplicationStore;
  const { t } = useTranslations(translations);
  return (
    <>
      <FilterButton onClick={() => setShowDrawer(true)}>
        <Inline space="small" alignY="center">
          <Text maxLines={1} size="small" baseline={false} weight="medium">
            {t('Filter and search')}
          </Text>
          {filtersStore.hasSelectedFilter && (
            <Badge tone="neutral">
              {filtersStore.selectedRrFilters.length.toString()}
            </Badge>
          )}
        </Inline>
      </FilterButton>
      <FilterDrawer showDrawer={showDrawer} setShowDrawer={setShowDrawer} />
    </>
  );
});
